import React from 'react';
import { Route } from 'react-router-dom';
import Collections from '../pages/collections/Collections';
import CreateCollection from '../pages/collections/CreateCollection';
import EditCollection from '../pages/collections/EditCollection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const collectionsRoutes = (
    <>
        {/* Collections List */}
        <Route
            path="/collections"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <Collections />
                </ProtectedRoute>
            }
        />

        {/* Create Collection */}
        <Route
            path="/collections/create"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <CreateCollection />
                </ProtectedRoute>
            }
        />

        {/* Edit Collection */}
        <Route
            path="/collections/:id/edit"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <EditCollection />
                </ProtectedRoute>
            }
        />
    </>
);

export default collectionsRoutes;
